'use strict';

angular.module('schoolbushubApp')
    .factory('Register', function ($resource) {
        return $resource('api/register', {}, {
        });
    });
